/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaskWorkflowItemStatus = {
    Incomplete: 'incomplete',
    Pending: 'pending',
    Passed: 'passed',
    Failed: 'failed',
} as const;
export type TaskWorkflowItemStatus = typeof TaskWorkflowItemStatus[keyof typeof TaskWorkflowItemStatus];


export function instanceOfTaskWorkflowItemStatus(value: any): boolean {
    for (const key in TaskWorkflowItemStatus) {
        if (Object.prototype.hasOwnProperty.call(TaskWorkflowItemStatus, key)) {
            if (TaskWorkflowItemStatus[key as keyof typeof TaskWorkflowItemStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaskWorkflowItemStatusFromJSON(json: any): TaskWorkflowItemStatus {
    return TaskWorkflowItemStatusFromJSONTyped(json, false);
}

export function TaskWorkflowItemStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemStatus {
    return json as TaskWorkflowItemStatus;
}

export function TaskWorkflowItemStatusToJSON(value?: TaskWorkflowItemStatus | null): any {
    return value as any;
}

export function TaskWorkflowItemStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TaskWorkflowItemStatus {
    return value as TaskWorkflowItemStatus;
}

